import Head from 'next/head';
import React, { useEffect } from 'react';
import { track_links } from 'utils/analytics/analytics';
import styles from './TrustPilotTwoLinesWidget.module.css';

const TrustPilotTwoLinesWidget = ({ widgetId = 'trustpilotRatingWidget' }) => {
  const loadWidget = () => {
    const trustbox = document.getElementById(widgetId);
    if (window.Trustpilot) {
      if (trustbox) {
        window.Trustpilot.loadFromElement(trustbox, true);
      }
    } else {
      // Trustbox Widget library has not yet downloaded, so wait a bit.
      setTimeout(loadWidget, 200);
    }
  };

  useEffect(() => {
    loadWidget();
    track_links('#' + widgetId, 'Clicked Trustpilot Link');
  }, []);

  return (
    <>
      <Head>
        <script
          type="text/javascript"
          src={
            'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
          }
          async
        />
      </Head>

      <div className={styles.container}>
        {/* <!-- TrustBox widget - Horizontal --> */}
        <div
          id={widgetId}
          className="trustpilot-widget"
          data-locale="en-GB"
          data-template-id="5406e65db0d04a09e042d5fc"
          data-businessunit-id="601882c742c1850001d9c876"
          data-style-height="28px"
          data-style-width="100%"
          data-token="5ddba033-182b-4e18-8e33-0f7f147d3a67"
        >
          <a
            href="https://uk.trustpilot.com/review/daymade.co.uk"
            target="_blank"
            rel="noopener"
          >
            Trustpilot
          </a>
        </div>
        {/*<!-- End TrustBox widget -->*/}
        <p className={styles.stats + ' aboutUsTypographyCaption'}>
          <strong>4.5/5</strong> based on <strong>3.4k reviews</strong>
        </p>
      </div>
    </>
  );
};

export default TrustPilotTwoLinesWidget;
